import { render } from "./ComputadorForm.vue?vue&type=template&id=1c101efa&scoped=true"
import script from "./ComputadorForm.vue?vue&type=script&lang=js"
export * from "./ComputadorForm.vue?vue&type=script&lang=js"

import "./ComputadorForm.vue?vue&type=style&index=0&id=1c101efa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c101efa"]])

export default __exports__